import { useEffect, useState } from 'react';

export default function useScrollFlags({ scrolledAt = 50, backToTopAt = 300 } = {}) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [showBackToTop, setShowBackToTop] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      setIsScrolled(y > scrolledAt);
      setShowBackToTop(y > backToTopAt);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [scrolledAt, backToTopAt]);

  return { isScrolled, showBackToTop };
}
